import { useOtecAxios } from "../../hooks/useOtecAxios"
import { OtecAdapters } from '../../controllers/adapters/otec.adapters';

const OtecServices = {
    GET_PARAMETROS: function () {
    	return useOtecAxios({method: 'GET', endpoint: 'otecSolicitudes.php', responseType: 'json'});
    },

    POST_DATOS_PERSONALES: function () {
    	return useOtecAxios({method: 'POST', endpoint: 'otecSolicitudes.php', responseType: 'json', adapters: OtecAdapters.POST_OBTENER_DATOS_SOLICITUD});
    },

    POST_GUARDAR_SOLICITUD: function () {
       return useOtecAxios({method: 'POST', endpoint: 'otecSolicitudes.php', responseType: 'json', adapters: OtecAdapters.POST_ENVIAR_DATOS_SOLICITUD});
    },

    POST_PRE_FIRMAR_DOCUMENTO: function () {
       return useOtecAxios({method: 'POST', endpoint: 'otecSolicitudes.php', responseType: 'json', adapters: OtecAdapters.POST_PRE_FIRMAR_DOCUMENTO});
    },

    POST_FIRMAR_DOCUMENTO: function () {
       return useOtecAxios({method: 'POST', endpoint: 'otecSolicitudes.php', responseType: 'json', adapters: OtecAdapters.POST_FIRMAR_DOCUMENTO});
    },

    POST_BAJA_SOLICITUD: function () {
       return useOtecAxios({method: 'POST', endpoint: 'otecSolicitudes.php', responseType: 'json', adapters: OtecAdapters.POST_BAJA_DOCUMENTO});
    },
}

export {
    OtecServices
}
